var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1829_11345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8915 4.8335C11.8723 4.8335 9.4248 7.281 9.4248 10.3002V47.7002C9.4248 50.7193 11.8723 53.1668 14.8915 53.1668H43.1081C46.1273 53.1668 48.5748 50.7193 48.5748 47.7002V16.9168L36.4915 4.8335H14.8915Z",
    fill: "#FA4E4E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8496 37.3842C35.2187 37.263 33.6485 36.6573 32.38 35.5671C29.9035 36.1121 27.5476 36.8993 25.1919 37.8687C23.3196 41.1998 21.5678 42.8957 20.0577 42.8957C19.7556 42.8957 19.3934 42.8353 19.1518 42.6534C18.4872 42.3507 18.125 41.6843 18.125 41.0182C18.125 40.473 18.2458 38.9589 23.9839 36.4755C25.3131 34.0528 26.3396 31.5697 27.1854 28.9654C26.4604 27.5118 24.8902 23.9381 25.9771 22.1214C26.3396 21.455 27.0646 21.0916 27.85 21.1523C28.4538 21.1523 29.0577 21.455 29.4202 21.9395C30.2056 23.0298 30.1452 25.3313 29.1181 28.7231C30.0848 30.5375 31.3509 32.1757 32.863 33.5685C34.1318 33.326 35.3999 33.1444 36.6684 33.1444C39.5074 33.2048 39.9303 34.5373 39.8699 35.3249C39.8699 37.3842 37.8764 37.3842 36.8496 37.3842ZM19.9372 41.1391L20.1184 41.0786C20.964 40.7759 21.6283 40.1703 22.1116 39.3827C21.2053 39.7461 20.4806 40.3518 19.9372 41.1394V41.1391ZM27.9705 22.9693H27.7892C27.7288 22.9693 27.608 22.9693 27.5476 23.0298C27.3059 24.0593 27.4872 25.1495 27.9101 26.1186C28.2726 25.0891 28.2726 23.9988 27.9705 22.9693ZM28.3934 31.7515L28.333 31.8723L28.2726 31.8119C27.7288 33.2051 27.1247 34.598 26.4604 35.9305L26.5812 35.8701V35.9909C27.9244 35.504 29.2961 35.0994 30.6886 34.7796L30.6282 34.7192H30.8095C29.9032 33.8105 29.0577 32.781 28.3934 31.7515ZM36.608 34.9615C36.0642 34.9615 35.5812 34.9615 35.0374 35.0823C35.6416 35.3853 36.2458 35.5064 36.8496 35.5671C37.2726 35.6275 37.6955 35.5671 38.0577 35.446C38.0577 35.2641 37.816 34.9615 36.608 34.9615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4409 15.7839H37.624L48.5745 26.7345L48.5745 16.9167L47.4409 15.7839Z",
    fill: "url(#paint0_linear_1829_11345)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9585 16.9167L48.5752 16.9167L36.4919 4.83341L36.4919 11.4501C36.4919 14.4692 38.9394 16.9167 41.9585 16.9167Z",
    fill: "#FDB8B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1829_11345",
    x: 9.4248,
    y: 4.49183,
    width: 39.1504,
    height: 49.0166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.683333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.170833
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1829_11345"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.683333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.170833
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1829_11345",
    result: "effect2_innerShadow_1829_11345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1829_11345",
    x1: 40.0785,
    y1: 13.3295,
    x2: 51.029,
    y2: 24.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9dfffb4e44320cd1cf75b98be53aed37.svg";
export { ForwardRef as ReactComponent };